import { icons } from "./icons.js";

export const menuitems = [
    {
        label: "Home",
        items: [
            { label: "Dashboard", icon: icons.dashboard, to: "/" },
            { label: "Users", icon: icons.users, to: "/users" },
            { label: "Affiliates", icon: icons.affiliate, to: "/affiliates" },
            // Real-money-only transaction queues (hidden when a sweepstakes brand is selected).
            { label: "Deposits", icon: icons.wallet, to: "/deposits", playMode: "real_money" },
            { label: "Credit Purchases", icon: icons.creditCard, to: "/credit-purchases", playMode: "real_money" },
            { label: "Withdrawals", icon: icons.bank, to: "/withdrawals", playMode: "real_money" },
            { label: "Inactivity Fees", icon: icons.clock, to: "/inactivity-fees", playMode: "real_money" },
            // Sweeps-only transaction queues (shown only when a sweepstakes brand is selected). #2158
            { label: "Purchases", icon: icons.purchase, to: "/purchases", playMode: "sweepstakes" },
            { label: "Redemptions", icon: icons.redemption, to: "/redemptions", playMode: "sweepstakes" },
            {
                label: "Verifications",
                icon: icons.verification,
                to: "/verifications"
            },
            { label: "AMOE", icon: icons.amo, to: "/amoe", playMode: "sweepstakes" },
            { label: "Anti-Fraud", icon: icons.fraud, to: "/anti-fraud" },
            { label: "Desync Queue", icon: icons.warning, to: "/desync-queue" },
            { label: "Issue Report", icon: "bi bi-github", to: "/cs-portal" },
            // {
            //     label: "Customer Support",
            //     icon: icons.support,
            //     to: "/customer-support"
            // } // Commented out for MVP - may return in future
        ]
    },
    {
        label: "Segmentation",
        items: [
            { label: "Segments", icon: icons.targeting, to: "/segments" }
        ]
    },
    {
        label: "Content Management",
        items: [
            { label: "Popups", icon: icons.popup, to: "/popups" },
            { label: "Carousel", icon: icons.carousel, to: "/carousels" },
            {
                label: "Player Targeting",
                icon: icons.targeting,
                to: "/player-targeting"
            },
            { label: "Promotions", icon: icons.promotion, to: "/promotions" },
            {
                label: "Credit Packages",
                icon: "bi bi-credit-card",
                items: [
                    {
                        label: "Store Packages",
                        icon: icons.package,
                        to: "/store-packages"
                    },
                    {
                        label: "Purchase Offers",
                        icon: icons.purchaseOffer,
                        to: "/purchase-offers"
                    },
                    {
                        label: "Amwest Credit Packs",
                        icon: "bi bi-box-seam",
                        to: "/amwest-credit-packs",
                        // Amwest is Giddyup's real-money processor; no sweeps analogue. #2158
                        playMode: "real_money"
                    }
                ]
            },
            {
                // Real-money-only construct (credits wallet + weighted USD cash payouts, RTP). #2158
                label: "Promo Credit Templates",
                icon: icons.promoCreditTemplate,
                to: "/promo-credit-templates",
                playMode: "real_money"
            },
            // LUCKY_WHEEL_DISABLED: {
            //     label: "Lucky Wheel Spin",
            //     icon: icons.luckyWheel,
            //     to: "/lucky-wheel-spin-configs"
            // },
            { label: "Quest System", icon: icons.quest, to: "/quests" },
            { label: "Daily Bonus", icon: icons.dailyBonus, to: "/daily-bonus" },
            {
                label: "Sitewide Notifications",
                icon: icons.sitewideNotification,
                to: "/sitewide-notifications"
            }
        ]
    },
    {
        label: "Game Management",
        items: [
            { label: "Games", icon: icons.game, to: "/games" },
            { label: "Game Catalogs", icon: icons.gameCatalog, to: "/game-catalogs" },
            {
                label: "Game Categories",
                icon: icons.gameCategory,
                to: "/game-categories"
            },
            {
                label: "Game Placement Editor",
                icon: icons.grid,
                to: "/game-placement-editor"
            },
            {
                label: "Game Providers",
                icon: icons.gameProvider,
                to: "/game-providers"
            },
            {
                label: "Game Studios",
                icon: icons.gameProvider,
                to: "/game-studios"
            }
        ]
    },
    {
        label: "Site Management",
        items: [
            {
                label: "Global Configurations",
                icon: icons.globalConfig,
                to: "/global-configurations"
            },
            {
                label: "Legal Documents",
                icon: icons.legalDocument,
                to: "/legal-documents"
            },
            {
                label: "Site Security",
                icon: icons.security,
                items: [
                    {
                        label: "Banned IPs",
                        icon: icons.bannedIP,
                        to: "/security/banned-ips"
                    },
                    {
                        label: "Banned Devices",
                        icon: icons.bannedDevice,
                        to: "/security/banned-devices"
                    },
                    {
                        label: "Banned Domains",
                        icon: icons.bannedDomain,
                        to: "/security/banned-domains"
                    }
                ]
            },
            {
                label: "Compliance",
                icon: icons.security,
                items: [
                    {
                        label: "Global Exclusions",
                        icon: icons.security,
                        to: "/compliance/global-exclusions"
                    }
                ]
            },
            { label: "Loyalty Levels", icon: icons.loyalty, to: "/loyalty-levels" },
            {
                label: "Refer a Friend",
                icon: icons.referFriend,
                to: "/refer-a-friend"
            },
            {
                label: "Payment Providers",
                icon: icons.paymentProvider,
                to: "/payment-providers"
            },
            {
                label: "Customer.io",
                icon: icons.extremePush,
                to: "/xtremepush"
            },
            { label: "Postbacks", icon: icons.postback, to: "/postbacks" },
            { label: "Deploy Dashboard", icon: "bi bi-rocket-takeoff", to: "/deploy-dashboard" },
            { label: "Platform Health", icon: "bi bi-heart-pulse", to: "/platform-health" }
        ]
    },
    {
        label: "Admin",
        items: [
            {
                label: "Maintenance Mode",
                icon: icons.maintenance,
                to: "/admin/maintenance"
            },
            {
                label: "Feature Flags",
                icon: icons.featureFlag,
                to: "/admin/feature-flags"
            },
            {
                label: "Bulk Users",
                icon: "bi bi-people-fill",
                to: "/admin/bulk-users"
            },
            {
                label: "Groups & Permissions",
                icon: "bi bi-shield-lock",
                to: "/admin/roles"
            },
            // {
            //     label: "Admin Users",
            //     icon: icons.users,
            //     items: [
            //         {
            //             label: "Users",
            //             icon: icons.user,
            //             to: "/admin/users"
            //         },
            //         {
            //             label: "Roles",
            //             icon: icons.document,
            //             to: "/admin/roles"
            //         },
            //         {
            //             label: "Audit History",
            //             icon: icons.list,
            //             to: "/admin/audit-history"
            //         }
            //     ]
            // } // Commented out for MVP - may return in future
        ]
    }
];

// Flattened { path -> playMode } lookup, derived from the same menuitems tree
// that renders the sidebar. This is the SINGLE source of truth for which play
// mode owns a route: MainMenu filters items by item.playMode for display, and the
// router guard calls playModeForPath() to block cross-play-mode navigation (deep
// links, bookmarks, redirects) — so the two can never disagree (#2158).
function buildPlayModeByPath(items, acc) {
    for (const item of items) {
        if (item.to && item.playMode) {
            acc[item.to] = item.playMode;
        }
        if (item.items) {
            buildPlayModeByPath(item.items, acc);
        }
    }
    return acc;
}

const PLAY_MODE_BY_PATH = menuitems.reduce(
    (acc, section) => buildPlayModeByPath(section.items ?? [], acc),
    {}
);

/**
 * The play mode ("real_money" | "sweepstakes") that owns a route path, or null if
 * the route is shared across play modes. Matches the longest tagged prefix so a
 * detail route (e.g. "/purchases/123") inherits its list's play mode.
 * @param {string} path route path (e.g. "/purchases")
 * @returns {string|null}
 */
export function playModeForPath(path) {
    let best = null;
    for (const prefix of Object.keys(PLAY_MODE_BY_PATH)) {
        if (path === prefix || path.startsWith(prefix + "/")) {
            if (!best || prefix.length > best.length) {
                best = prefix;
            }
        }
    }
    return best ? PLAY_MODE_BY_PATH[best] : null;
}
